import React from 'react';
import PeopleOutlined from '@mui/icons-material/PeopleOutlined';
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import StatCard from '../StatCard'

const CardUsuarios = (props) => {
  const totalUsuarios = useSelector((state) => state.dashboard?.dashboard?.totalUsuarios)

  return (
    <StatCard
      {...props}
      label="Total de usuários cadastrados"
      value={totalUsuarios ? totalUsuarios : 0}
      icon={<PeopleOutlined />}
    />
  );
}

CardUsuarios.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
}

export default CardUsuarios
